import { LoadingRTBase } from "./LoadingRT.generated";
import { DataCenter } from "./DataCenter";
import { Main } from "./Main";
import * as consts from "./play/const";
import * as Env from "./Env";


const { regClass, property } = Laya;
@regClass('xmaaYG8AQ1yC07pr_JvyPA')
export default class LoadingRT extends LoadingRTBase {
    static instance: LoadingRT = null;
    private _center: Laya.Sprite;

    constructor() {
        super();
        LoadingRT.instance = this;
    }

    onAwake(): void {
        this._center = this.getChildByName("center") as Laya.Sprite;
        let img = this.getChildByName("bg") as Laya.Image;
        DataCenter.instance.setScreenBg(img);
        this.InitLoad();
        DataCenter.instance.adjustScreen(this._center);
    }

    async InitLoad() {
        await Env.Init(() => {
            Env.loadingStart();
            let DB = DataCenter.instance;
            let resArr: Array<any> = [
                { url: "scenes/GamePlay.ls", type: Laya.Loader.HIERARCHY },
                { url: "scenes/Main.ls", type: Laya.Loader.HIERARCHY },
                //{ url: "prefab/Toy/Apple.lh", type: Laya.Loader.HIERARCHY },
                { url: "resources/game/level_special.json", type: Laya.Loader.JSON },
                { url: "resources/game/block.json", type: Laya.Loader.JSON }
                ,{ url: "resources/game/levels.json", type: Laya.Loader.JSON }
                ,{ url: "atlas/comp/img_wall_01.png", type: Laya.Loader.IMAGE }
                ,{ url: "atlas/comp/img_wall_02.png", type: Laya.Loader.IMAGE }
                ,{ url: "atlas/comp/bg_gameplay.png", type: Laya.Loader.IMAGE }
                ,{ url: "atlas/end/small_bg.png", type: Laya.Loader.IMAGE }
                ,{ url: "atlas/xmas_mode/img_wall_01.png", type: Laya.Loader.IMAGE }
                ,{ url: "atlas/xmas_mode/img_wall_02.png", type: Laya.Loader.IMAGE }
                ,{ url: "atlas/xmas_mode/bg_gameplay.png", type: Laya.Loader.IMAGE }
            ];
            Laya.loader.load(resArr, null, Laya.Handler.create(this, this.onLoading, null, false)).then((res: any) => {                
                DB.initSpecialData(res[2].data);
                DB.initBlockData(res[3].data);

                let l_data = res[4].data;
                for (let i = 0; i < l_data.length; i++) {
                    let lv = l_data[i];
                    DB.all_levels[lv[0] - 1] = lv;
                }

                this.progress.value = 0.5;
                Env.Login(() => {
                    this.progress.value = 1;
                    Laya.SoundManager.playMusic("resources/cdn/bgm.mp3");
                    Env.loadingStop();
                    if(DB.level_id == 1) {
                        DB.free_mode = false;
                        LoadingRT.instance.StartMode(consts.MODE_COMMON);
                    }
                    else
                        Laya.Scene.open("scenes/Main.ls");
                });
            });

            Laya.loader.on(Laya.Event.ERROR, this, this.onError);
        });
    }

    onError(err: string): void {
        console.log("error load: " + err);
    }

    onLoading(progress: number): void {
        if (progress > 0.92) this.progress.value = 0.95;
        else this.progress.value = progress;
        //console.log("加载进度: " + progress, this.progress.value);
    }

    public static getUUID(): string {
            const timestamp = Date.now().toString(36);
            const randomStr = Math.random().toString(36);            
            return `${timestamp}_${randomStr}}`;

    };


    async StartMode(mode: number) {
        let level = DataCenter.instance.level_info[mode];        
        DataCenter.instance.level_mode = mode;
        DataCenter.instance.level_id = level;
        //Env.SetItem("cur_level", level);
        Main.startLevel(level);
    }
    async levelEnd(win : boolean, callBack : () => void) {
        var DB = DataCenter.instance;
        let level = DB.level_id;
        if(win)
        {
            level++;
            //Env.SetItem("cur_level", level);
            let key = consts.MODE_NAMES[DB.level_mode];
            Env.SetItem(key, level);
            DB.level_info[DB.level_mode] = level;
            
            DB.level_id = level;
            DB.level_data = DB.getLevelData(level);
        }            
        callBack();
    }
}